// import React from 'react'
// import USTemplateDefault from 'src/components/template/us'
// import { leagueIds, sportIds } from 'src/constants'

// export default (props) => {
//   return (
//     <USTemplateDefault
//       location={props.location}
//       lang="en"
//       market="us"
//       title={
//         <>
//           Watch the NBA <span className="desktop-line-break">on NBC</span>
//         </>
//       }
//       video={'https://assets.fubo.tv/marketing/lp/videos/compressed/NBAonNBC_10s_LP_16x9_3Mb.mp4'}
//       videoMobile={'https://assets.fubo.tv/marketing/lp/videos/mobile/NBAonNBC_10s_LP_1x1_3Mb.mp4'}
//       subtitle={'Catch live games, shows and highlights'}
//       showRSN={true}
//       networkSet="basketball"
//       customNetworks={['nbc']}
//       league="nba"
//       sportId={sportIds.Basketball}
//       leagueId={leagueIds.NBA}
//       matchtickerSportId={sportIds.Basketball}
//       matchtickerLeagueName="NBA"
//       matchtickerLeagueId={leagueIds.NBA}
//     />
//   )
// }

// TEMPORARY NBC DISPUTE
import React from 'react'
import RedirectTemplate from 'src/components/template/redirect'
export default (props) => <RedirectTemplate location={props.location} destination="/tv/" />
